import { render, staticRenderFns } from "./ConditionalLicense.vue?vue&type=template&id=b4c981f4"
import script from "./ConditionalLicense.vue?vue&type=script&lang=js"
export * from "./ConditionalLicense.vue?vue&type=script&lang=js"
import style0 from "./ConditionalLicense.vue?vue&type=style&index=0&id=b4c981f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports